import clsx from 'clsx'

import {classes, variantClasses} from './IconNumber.classes'
import {Props} from './IconNumber.types'

export function IconNumber({variant, number}: Props): React.ReactElement {
  return <div className={clsx(classes.root, variant && variantClasses[variant])} data-number={number} />
}
